import { z } from "zod";
/**
 * Common WorkShift enums and schemas - shared between domain and DTO
 * Contains enums, labels, and common field definitions
 */
export const zWorkShiftStatusSchema = z.enum([
    "PLANNED",
    "IN_PROGRESS",
    "COMPLETED",
    "CANCELLED",
]);
export const WORK_SHIFT_STATUS_LABELS = {
    [zWorkShiftStatusSchema.enum.PLANNED]: "Запланирована",
    [zWorkShiftStatusSchema.enum.IN_PROGRESS]: "Выполняется",
    [zWorkShiftStatusSchema.enum.COMPLETED]: "Завершена",
    [zWorkShiftStatusSchema.enum.CANCELLED]: "Отменена",
};
export const WORK_SHIFT_STATUS_COLORS = {
    [zWorkShiftStatusSchema.enum.PLANNED]: "blue",
    [zWorkShiftStatusSchema.enum.IN_PROGRESS]: "green",
    [zWorkShiftStatusSchema.enum.COMPLETED]: "green",
    [zWorkShiftStatusSchema.enum.CANCELLED]: "red",
};
// Базовая схема для WorkShift (общие поля)
export const zWorkShiftCommonSchema = z.object({
    id: z.string(),
    idTechnician: z.string(),
    status: zWorkShiftStatusSchema.default("PLANNED"),
});
export const getWorkShiftStatusLabel = (status) => {
    return WORK_SHIFT_STATUS_LABELS[status];
};
export const getWorkShiftStatusColor = (status) => {
    return WORK_SHIFT_STATUS_COLORS[status];
};
